module.exports = __webpack_public_path__ + "img/document.cbc65d23.png";